import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MenuItem = props => {
  const { link, name } = props;
  const { t } = useTranslation('header');
  return (
    <NavLink to={link} className="responsive-menu-link">
      {t(`${name}`)}
    </NavLink>
  );
};

MenuItem.propTypes = {
  link: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};

export default MenuItem;
